module.exports = __webpack_public_path__ + "img/38.24a938fa.jpg";